<template>
  <div>
    <v-layout>
      <v-row no-gutters>
        <div style="width: 50%" class="pa-1">
          <v-text-field label="width" v-model="width"></v-text-field>
        </div>
        <div style="width: 50%" class="pa-1">
          <v-text-field label="height" v-model="height"></v-text-field>
        </div>
      </v-row>
    </v-layout>
    <v-layout>
      <v-row no-gutters>
        <div style="width: 50%" class="pa-1">
          <v-text-field label="init-x" v-model="initX"></v-text-field>
        </div>
        <div style="width: 50%" class="pa-1">
          <v-text-field label="init-y" v-model="initY"></v-text-field>
        </div>
      </v-row>
    </v-layout>
    <v-layout>
      <v-text-field label="Window Title" v-model="title"></v-text-field>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: 'Lorem ipsum',
      width: 200,
      height: 200,
      initX: 40,
      initY: 40,
    };
  },
  methods: {
    getSettings() {
      return {
        title: this.title,
        width: parseInt(this.width),
        height: parseInt(this.height),
        initX: parseInt(this.initX),
        initY: parseInt(this.initY),
      };
    },
  },
};
</script>

<style></style>
